import React, { useState } from "react"
import { Box, Flex, Heading, Text } from "@chakra-ui/react"
import { Tabs } from "../components/tabs"
import { SnapLogoPrimary } from "../components/commons/SnapLogo"
import { Colors } from "../theme/colors"
import { Paths } from "../common/commonConstants"
import { useLocation, useNavigate } from "react-router-dom"
import { SubPage } from "../components/SubPage"

export const TermsAndConditions = (): JSX.Element => {
  const location = useLocation()
  const route = location.pathname
  const navigate = useNavigate()

  const getDefaultTabIndex = (): 0 | 1 => {
    if (route === Paths.TERMSANDCONDITIONS) {
      return 0
    }

    return 1
  }

  const [clickedTabIndex, setClickedTabIndex] = useState<number>(getDefaultTabIndex())

  return (
    <SubPage>
      <Box w={["180px", "180px", "980px"]} margin={"auto"} pt={["23px", "23px", "3px"]}>
        <SnapLogoPrimary props={{ w: ["180px", "180px", "131px"] }} />
      </Box>
      <Box w={["100%", "100%", "705px"]} margin={"auto"} mt={["45px", "45px", "0"]} px={["26px", "26px", "0"]}>
        <Tabs
          tabs={["TERMS & CONDITIONS", "PRIVACY POLICY"]}
          defaultTabIndex={clickedTabIndex}
          tabClickHandler={(tabType, tabIndex) => {
            setClickedTabIndex(tabIndex)
            if (tabIndex === 0) {
              navigate(Paths.TERMSANDCONDITIONS)
            }
            if (tabIndex === 1) {
              navigate(Paths.PRIVACYPOLICY)
            }
          }}
          tabButtonStyles={{
            pt: "0",
            mt: "0",
            pb: ["16px", "16px", "10px"],
            fontSize: "24px",
            lineHeight: "24px",
            fontFamily: "Work Sans",
            fontWeight: "500"
          }}
          tabContainerStyles={{ pos: "relative", top: "-4px", mb: [0, 0, 0] }}
        />
      </Box>
      <Box display={["none", "none", "block"]} h="1px" bg={Colors.Primary.accent} pos={"relative"} top="-5px"></Box>
      <Box margin="auto" mt={["6px", "6px", "35px"]} p={[4, 4, 0]} w={["100%", "100%", "880px"]}>
        <Box w={["auto", "auto", "880px"]}>
          {clickedTabIndex === 0 && (
            <Box py="29px" mb="30px" pt={["0", "0", "1"]}>
              <Heading variant={"RHeading3PT"} my="0">
                Introduction{" "}
              </Heading>
              <Heading variant={["RHeading4", "RHeading4", "RHeading3PT"]} my="4">
                These terms and conditions create a contract between you and Snap Fire Systems (the “Agreement”). Please read the Agreement carefully.{" "}
              </Heading>
              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
                <br />
                <br />
              </Text>
              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.
              </Text>
              <Heading mt="45" variant={"RHeading3PT"}>
                B: Using our services{" "}
              </Heading>
              <Heading my="4" variant={"RHeading3PT"}>
                Account{" "}
              </Heading>
              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.{" "}
              </Text>
              <Text variant="termsConditionaPara">Sed ut perspiciatis unde omnis iste natus error sit voluptatem:</Text>
              <Box fontFamily="PT Sans" fontSize="16px" fontWeight="400" lineHeight="24px" marginLeft={"25px"} marginY="10px">
                <ol>
                  <li>Ratione voluptatem sequi nesciunt. </li>
                  <li>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,</li>
                  <li>consectetur, adipisci velit, sed quia non numquam eius modi </li>
                  <li>tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam. </li>
                </ol>
              </Box>
              <Heading variant={"RHeading3PT"} my="4">
                Privacy{" "}
              </Heading>
              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore.
              </Text>
              <Text variant="termsConditionaPara" my="3">
                veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut
                fugit,
              </Text>
              <Text variant="termsConditionaPara" my="3">
                sed quia consequuntur magni dolores eos qui.
              </Text>
              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>
              <Heading variant={"RHeading3PT"} my="4">
                Third party services{" "}
              </Heading>
              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>
              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.
              </Text>
              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>
              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.
              </Text>
              <Heading variant={"RHeading3PT"} my="4">
                Services and content usage rules
              </Heading>
              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>
              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.
              </Text>
              <Heading variant={"RHeading3PT"} my="4">
                Downloads
              </Heading>
              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.{" "}
              </Text>
              <Heading variant={"RHeading3PT"} my="4">
                Retaining your information{" "}
              </Heading>
              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.{" "}
              </Text>
              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.
              </Text>
              <Heading variant={"RHeading3PT"} my="4">
                C: Your submissions to our services{" "}
              </Heading>
              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.{" "}
              </Text>
              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas.
              </Text>
              <Text mt="4" variant={"Body1Regular"} fontSize={"15px"}>
                Date of last revision: July 10, 2023
              </Text>
            </Box>
          )}
          {clickedTabIndex === 1 && (
            <Box py="29px" mb="30px" mt="0" pt={[0, 0, 1]}>
              <Heading variant={"RHeading3PT"} my="0">
                A: Introduction to our services{" "}
              </Heading>

              <Heading variant={["RHeading4", "RHeading4", "RHeading3PT"]} my="4">
                When you use our services, you’re trusting us with your information. We value this trust and do our best to ensure your information is
                protected and controlled by you.
              </Heading>

              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>

              <Heading variant={"RHeading3PT"} my="4" pt="30px">
                Information Snap collects
              </Heading>
              <Text variant="termsConditionaPara">Sed ut perspiciatis unde omnis iste natus error sit voluptatem:</Text>
              <Box fontFamily="PT Sans" fontSize="16px" fontWeight="400" lineHeight="24px" marginLeft={"25px"} marginY="10px">
                <ol>
                  <li>Ratione voluptatem sequi nesciunt. </li>
                  <li>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, </li>
                  <li>consectetur, adipisci velit, sed quia non numquam eius modi </li>
                  <li>tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.</li>
                </ol>
              </Box>
              <Heading variant={"RHeading3PT"} my="4">
                Why Snap collects data
              </Heading>

              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore.{" "}
              </Text>

              <Text variant="termsConditionaPara" my="3">
                sed quia consequuntur magni dolores eos qui. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
                laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo
                enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>

              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam
              </Text>

              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>

              <Heading variant={"RHeading3PT"} my="4">
                Your privacy controls
              </Heading>

              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>

              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.
              </Text>

              <Heading variant={"RHeading3PT"} my="4">
                Sharing your information
              </Heading>

              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>

              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.
              </Text>

              <Heading variant={"RHeading3PT"} my="4">
                Keeping your information secure
              </Heading>

              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.
              </Text>

              <Heading variant={"RHeading3PT"} my="4">
                Deleting your information
              </Heading>

              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>

              <Heading variant={"RHeading3PT"} my="4" pt="0">
                Retaining your information
              </Heading>

              <Text variant="termsConditionaPara" my="3">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>

              <Text variant="termsConditionaPara" my="3">
                Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam.
              </Text>

              <Heading variant={"RHeading3PT"} my="4">
                About this policy
              </Heading>

              <Text variant="termsConditionaPara" my="3" mb="0">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui.
              </Text>
              <Text mt="4" variant={"Body1Regular"} fontSize={"15px"}>
                Date of last revision: July 10, 2023
              </Text>
            </Box>
          )}
        </Box>
      </Box>
      <Box textAlign={"center"} pt="6" fontSize={"12px"} w="100%" maxW="525px" margin={"auto"} pb="16px">
        <Box>2023 © Snap Fire Systems Pty Ltd.</Box>
        <Flex align={"center"} justify={"space-between"} pt="6px" margin="auto">
          <Box>2023 © IG6 Pty Ltd. All Rights Reserved.</Box>
          <Box>ABN 73 120 808 326 | Accreditation - ISO: 9001</Box>
        </Flex>
      </Box>
    </SubPage>
  )
}
